import { gsap } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";

export default class HomeScrollAnimations {
	constructor(container) {
        this.headerBar = document.querySelector('[data-header]');
		this.headerBarLogo = this.headerBar.querySelector('[data-logo]');
		this.headerBarBackground = this.headerBar.querySelector('[data-header-background]');

        this.container = container;

		this.header = this.container.querySelector('[data-home-header]');
		this.headerImages = this.header.querySelectorAll('.c-img-video');

		this.headerLogo = this.container.querySelector('[data-home-header-logo]');
		this.headerLogoSvg = this.headerLogo.querySelector('svg');

		this.headerOne = this.container.querySelector('[data-home-header-one]');
		this.headerOneContent = this.headerOne.querySelector('[data-home-header-one-content]');

		this.headerTwo = this.container.querySelector('[data-home-header-two]');
		this.headerFour = this.container.querySelector('[data-home-header-four]');


		let mm = gsap.matchMedia();

		mm.add({
			isMobile: "(max-width:991px)",
			isDesktop: "(min-width:992px)",
		}, (context) => {
			let { isMobile } = context.conditions;

			gsap.to(this.headerLogoSvg, {
				scale: () => {
					return isMobile ? 146.5/this.headerLogoSvg.getBoundingClientRect().width : this.headerBarLogo.getBoundingClientRect().width/this.headerLogoSvg.getBoundingClientRect().width;
				},
				translateY: () => {
					return isMobile ? 10-this.headerLogoSvg.getBoundingClientRect().top+'px' : this.headerBarLogo.getBoundingClientRect().top-this.headerLogoSvg.getBoundingClientRect().top+'px';
				},
				duration: 1,
				ease: 'none',
				onComplete: () => {
					this.headerBar.classList.add('is-visible');
					this.headerLogo.remove(); // We don't need this inline logo anymore
				},
				scrollTrigger: {
					trigger: this.headerOne,
					start: 'top top',
					end: 'top -150%',
					scrub: 0.25,
					invalidateOnRefresh: true,
					once: true
				}
			});

		});

		gsap.to(this.headerOneContent, {
			filter: "blur(20px)",
			opacity: 0,

			duration: 1,
			ease: 'none',
			scrollTrigger: {
				trigger: this.headerTwo,
				start: 'top 115%',
				end: 'top 50%',
				scrub: 1
			}
		});

		gsap.to(this.headerTwo, {
			opacity: 0,

			duration: 1,
			ease: 'sine.inOut',
			scrollTrigger: {
				trigger: this.headerTwo,
				start: 'center 80%',
				end: 'top top',
				scrub: 1,
			}
		});

		ScrollTrigger.create({ // Turn header white again
			trigger: this.headerFour,
			start: 'top 110',
			end: 'top 110',
			onEnter: self => {
				this.headerBar.classList.remove('c-header--home');
			},
			onEnterBack: self => {
				this.headerBar.classList.add('c-header--home');
			},
		});

		gsap.to(this.headerImages, { // Fade header media to black
			opacity: 0.3,

			duration: 1,
			ease: 'none',
			scrollTrigger: {
				trigger: this.headerFour,
				start: 'top 125%',
				end: 'top top',
				scrub: 0.5
			}
		});

    }

    destroy() {
        //
	}

}
